import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("dda0fa2123", "._72f4bedabdb649b6__overlay{background:color-mix(in sRGB,var(--wpds-color-background-surface-neutral-strong,#fff) 60%,transparent);height:100%;inset:0;position:absolute;z-index:1}");
}
export default {"overlay":"_72f4bedabdb649b6__overlay"};
